<template>
    <div class="navBar">
        <el-tag :type="actId==0 ? undefined : 'info'" @click="goHome">首页</el-tag>
        <el-tag closable :type="actId==tag.id ? undefined : 'info'"
            v-for="tag in tags" :key="tag.id"
            @click="clickTag(tag)"
            @close="closeTag(tag)">
            {{tag.name}}
        </el-tag>
    </div>
</template>

<script>
export default {
    props: {
        actId: {
            type: Number,
            default() {
                return 0
            }
        },
        tags: {
            type: Array,
            default() {
                return [];
            },
        }
    },
    methods: {
        clickTag(tag){
            this.$emit("tagClick", {tag: tag})
        },
        closeTag(tag) {
            let index = this.tags.indexOf(tag)
            this.$emit("tagClose", {index: index})
        },
        goHome(){
            let tag = {
                pid: 0,
                id: 0,
                name: '首页',
                mdesc: 'Home',
                linkurl: "/home"
            }
            this.clickTag(tag)
        }
    },
};
</script>